import { useQuery, useMutation, useQueryClient } from 'react-query';
import { UserHttpService } from 'core/services/user';

const useReferences = (cvId = null) => {
    const queryClient = useQueryClient();

    // Query for fetching references
    const { data, isLoading, error } = useQuery(['references', cvId], async () => {
        const response = await UserHttpService.listReferences(cvId);
        return response.results || [];
    });

    // Mutation for adding a reference
    const addReferenceMutation = useMutation(
        async (newReference) => {
            const referenceData = {
                name: newReference.name,
                position: newReference.position,
                location: newReference.location,
                email: newReference.email,
                phone_number: newReference.phone_number
            };
            return await UserHttpService.createReference(referenceData);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch references query
                queryClient.invalidateQueries(['references', cvId]);
            }
        }
    );

    // Mutation for updating a reference
    const updateReferenceMutation = useMutation(
        async (updatedReference) => {
            const referenceData = {
                name: updatedReference.name,
                position: updatedReference.position,
                location: updatedReference.location,
                email: updatedReference.email,
                phone_number: updatedReference.phone_number
            };
            return await UserHttpService.updateReference(updatedReference.id, referenceData);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch references query
                queryClient.invalidateQueries(['references', cvId]);
            }
        }
    );

    // Mutation for deleting a reference
    const deleteReferenceMutation = useMutation(
        async (id) => {
            return await UserHttpService.deleteReference(id);
        },
        {
            onSuccess: () => {
                // Invalidate and refetch references query
                queryClient.invalidateQueries(['references', cvId]);
            }
        }
    );

    return {
        references: data || [],
        isLoading,
        error: error ? error.message : null,
        addReference: addReferenceMutation.mutateAsync,
        updateReference: updateReferenceMutation.mutateAsync,
        deleteReference: deleteReferenceMutation.mutateAsync
    };
};

export default useReferences; 